import React from 'react';
export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: Array<{
    value: string;
    label: string;
  }>;
}
export function Select({
  label,
  error,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-361">
      {label && <label className="block text-sm font-medium mb-1" style={{
      color: 'var(--nmhl-text-primary)'
    }} data-id="element-362">
          {label}
        </label>}
      <select className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:border-transparent ${error ? 'border-red-500' : 'border-slate-300'} ${className}`} style={{
      '--tw-ring-color': 'var(--nmhl-burgundy)'
    } as React.CSSProperties} {...props} data-id="element-363">
        {options.map(option => <option key={option.value} value={option.value} data-id="element-364">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-365">{error}</p>}
    </div>;
}